var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"info"}},_vm._l((_vm.infoList),function(info,index){return _c('p',{key:info,staticClass:"infoItem"},[_vm._v("["+_vm._s(index)+"] "+_vm._s(info))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }